var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("media-buttons", {
    attrs: {
      "container-class": _vm.containerClass,
      options: _vm.estate.media,
      active: _vm.active,
      icons: true,
      "decore-active": false
    },
    on: { selected: _vm.mediaSelected }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }